<div
  id="content"
  class="allcp-form"
  ng-controller="CustomerOrderAnalyticController"
  ng-init="init()"
>
  <div ng-include="'modules/customer/partials/top_menu.html'"></div>
  <div class="row mt20">
    <div class="col-md-12 mb20">
      <div class="panel date-range">
        <div class="panel-body" style="margin-top: 0px;padding-top: 0px !important;">
          <div class="row">
            <div class="col-md-8 col-xs-12 col-sm-12">
              <div class="card panel panel-tile border-chart">
                <div class="panel-body p20">
                  <div class="card-header">
                    <h4>Account Overview</h4>
                    <div class="card-header-action">
                      <div class="badge badge-success">Active</div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div class="summary-item">
                      <ul class="list-unstyled list-unstyled-border">
                        <li class="media">
                          <div class="row">
                            <div class="col-md-6 col-xs-12 d-flex align-items-center">
                              <div class="avatar-item">
                                <img
                                  class="mr-3 rounded-circle img-fluid"
                                  width="150"
                                  height="150"
                                  src="https://api.dicebear.com/7.x/initials/svg?seed={{authenticatedUser.full_name}}&radius=50&backgroundType=gradientLinear"
                                  alt="demo"
                                />
                              </div>
                            </div>
                            <div class="col-md-6 col-xs-12 col-sm-12 text-right">
                              <a
                                href="/dqr?qr=https://hodxpress.com/merchant/register?ref={{authenticatedUser.user_reference_code}}"
                                target="_blank"
                                class="openPopup"
                                data-poptitle="Referral Link QR Code"
                              >
                                <img
                                    class="mr-3 img-fluid px-md-5"
                                    width="100%"
                                    ng-src="{{ authenticatedUser.qr }}"
                                    alt=""
                                />

                                <span style="text-align: center;display: block;">Download</span>
                              </a>
                            </div>
                          </div>
                        </li>
                        <li class="media">
                          <div class="media-body">
                            <div class="text-small">Registered</div>
                            <div class="media-title">{{ authenticatedUser.created_at.date | amDateFormat:'MM/DD/YYYY' }}</div>
                          </div>
                        </li>
                        <li class="media">
                          <div class="media-body">
                            <div class="text-small">Name</div>
                            <div class="media-title">
                              {{authenticatedUser.full_name}}
                            </div>
                          </div>
                        </li>
                        <li class="media">
                          <div class="media-body">
                            <div class="text-small">
                                Default Referral URL
                              <a
                                href="https://hodxpress.com/merchant/register?ref={{authenticatedUser.user_reference_code}}"
                                target="_blank"
                                class="d-sm-none"
                                data-toggle="tooltip"
                                title=""
                                data-original-title="https://hodxpress.com/merchant/register?ref={{authenticatedUser.user_reference_code}}"
                                ><span class="text-small"
                                  ><i
                                    class="fa fa-fw fa-external-link-alt"
                                  ></i></span
                              ></a>
                            </div>
                            <div class="media-title">
                              <a
                                class="d-none d-sm-block"
                                href="https://hodxpress.com/merchant/register?ref={{authenticatedUser.user_reference_code}}"
                                target="_blank"
                                data-toggle="tooltip"
                                title=""
                                data-original-title="https://hodxpress.com/merchant/register?ref={{authenticatedUser.user_reference_code}}"
                              >
                                https://hodxpress.com/merchant/register?ref={{authenticatedUser.user_reference_code}}
                              </a>
                              <div class="d-sm-none">
                                <div class="form-group">
                                  <div class="input-group mb-3">
                                    <input
                                      type="text"
                                      class="form-control form-control-sm"
                                      value="https://hodxpress.com/merchant/register?ref={{authenticatedUser.user_reference_code}}"
                                      id="mypeppyrefurlid"
                                      readonly=""
                                    />
                                    <div class="input-group-append">
                                      <button
                                        class="btn btn-primary btn-sm"
                                        type="button"
                                        ng-click="copyText('https://hodxpress.com/merchant/register?ref=' + authenticatedUser.user_reference_code)"
                                        data-toggle="tooltip"
                                        title=""
                                        data-original-title="Copy link"
                                      >
                                        <i class="fa fa-copy fa-fw"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- <div class="col-4">
              <div class="panel panel-tile border-chart text-center">
                <div class="panel-body p20">
                  <h4 class="mbn mtn">
                    <a
                      href="#"
                      ng-click="copyText('https://hodxpress.com/merchant/register?ref=' + authenticatedUser.user_reference_code)"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      Your reference link <small> (for Merchant)</small>
                      <svg
                        width="24px"
                        height="24px"
                        style="margin-left: 4px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#a)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8 5h7.795c1.115 0 1.519.116 1.926.334.407.218.727.538.945.945.218.407.334.811.334 1.926V16a1 1 0 1 0 2 0V8.128c0-1.783-.186-2.43-.534-3.082a3.635 3.635 0 0 0-1.512-1.512C18.302 3.186 17.655 3 15.872 3H8a1 1 0 0 0 0 2zm7.721 2.334C15.314 7.116 14.91 7 13.795 7h-7.59c-1.115 0-1.519.116-1.926.334a2.272 2.272 0 0 0-.945.945C3.116 8.686 3 9.09 3 10.205v7.59c0 1.114.116 1.519.334 1.926.218.407.538.727.945.945.407.218.811.334 1.926.334h7.59c1.114 0 1.519-.116 1.926-.334.407-.218.727-.538.945-.945.218-.407.334-.811.334-1.926v-7.59c0-1.115-.116-1.519-.334-1.926a2.272 2.272 0 0 0-.945-.945z"
                            fill="#828c95"
                          />
                        </g>
                        <defs>
                          <clipPath id="a">
                            <path fill="#828c95" d="M0 0h24v24H0z" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </h4>
                
                  <h4 class="mt40">
                    <a
                      href="#"
                      ng-click="copyText(authenticatedUser.user_reference_code)"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      {{authenticatedUser.user_reference_code}}
                      <svg
                        width="24px"
                        height="24px"
                        style="margin-left: 4px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#a)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8 5h7.795c1.115 0 1.519.116 1.926.334.407.218.727.538.945.945.218.407.334.811.334 1.926V16a1 1 0 1 0 2 0V8.128c0-1.783-.186-2.43-.534-3.082a3.635 3.635 0 0 0-1.512-1.512C18.302 3.186 17.655 3 15.872 3H8a1 1 0 0 0 0 2zm7.721 2.334C15.314 7.116 14.91 7 13.795 7h-7.59c-1.115 0-1.519.116-1.926.334a2.272 2.272 0 0 0-.945.945C3.116 8.686 3 9.09 3 10.205v7.59c0 1.114.116 1.519.334 1.926.218.407.538.727.945.945.407.218.811.334 1.926.334h7.59c1.114 0 1.519-.116 1.926-.334.407-.218.727-.538.945-.945.218-.407.334-.811.334-1.926v-7.59c0-1.115-.116-1.519-.334-1.926a2.272 2.272 0 0 0-.945-.945z"
                            fill="#828c95"
                          />
                        </g>
                        <defs>
                          <clipPath id="a">
                            <path fill="#828c95" d="M0 0h24v24H0z" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </h4>

                  <h4 class="mb10 mt30">
                    <a
                      href="#"
                      ng-click="copyText('https://hodxpress.com/sales/register?ref=' + authenticatedUser.user_reference_code)"
                      style="
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      Your reference link <small> (for Sales)</small>
                      <svg
                        width="24px"
                        height="24px"
                        style="margin-left: 4px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#a)">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M8 5h7.795c1.115 0 1.519.116 1.926.334.407.218.727.538.945.945.218.407.334.811.334 1.926V16a1 1 0 1 0 2 0V8.128c0-1.783-.186-2.43-.534-3.082a3.635 3.635 0 0 0-1.512-1.512C18.302 3.186 17.655 3 15.872 3H8a1 1 0 0 0 0 2zm7.721 2.334C15.314 7.116 14.91 7 13.795 7h-7.59c-1.115 0-1.519.116-1.926.334a2.272 2.272 0 0 0-.945.945C3.116 8.686 3 9.09 3 10.205v7.59c0 1.114.116 1.519.334 1.926.218.407.538.727.945.945.407.218.811.334 1.926.334h7.59c1.114 0 1.519-.116 1.926-.334.407-.218.727-.538.945-.945.218-.407.334-.811.334-1.926v-7.59c0-1.115-.116-1.519-.334-1.926a2.272 2.272 0 0 0-.945-.945z"
                            fill="#828c95"
                          />
                        </g>
                        <defs>
                          <clipPath id="a">
                            <path fill="#828c95" d="M0 0h24v24H0z" />
                          </clipPath>
                        </defs>
                      </svg>
                    </a>
                  </h4>
                </div>
                <div class="panel-footer p12">
                  <strong>Reference Info</strong>
                </div>
              </div>
            </div> -->

            <div class="col-md-4 col-xs-12 col-sm-12">
              <div class="panel panel-tile border-chart text-center">
                <div class="panel-body p20">
                  <h2 class="mbn mtn text-dark">
                    0$ / 0$
                  </h2>
                </div>
                <div class="panel-footer p12">
                  <strong>Earning</strong>
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <canvas
                id="doughnut"
                class="chart chart-doughnut"
                ng-if="chartData"
                chart-data="chartData"
                chart-labels="series"
                chart-legend="true"
              >
              </canvas>
            </div>
            <div class="col-md-6">
              <canvas
                id="line"
                class="chart chart-line"
                chart-data="barChartData"
                chart-labels="data.chart.labels"
                chart-series="series"
                chart-colours="lineColors"
                chart-legend="true"
              >
              </canvas>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
